/**
 * defa.routers.RecipientRouter
 * The router for the RecipientController
 * @version 1.2.0
 */
const RecipientRouter = Mn.AppRouter.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	appRoutes: {
		'devices/:id/recipients(/)' : 'showUnitRecipients',
		'devices/:id/recipients/new(/)' : 'showNewUnitRecipients',
		'devices/:id/recipients/:subId/edit(/)' : 'showUnitRecipient',
		'devices/:id/recipients/:subId/delete' : 'showRecipientDelete',
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );

export default RecipientRouter;